import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import React from "react";
import {
  CoinMetricsCardContainer,
  CoinMetricsCardStyled,
  CoinMetricsList
} from "./styles";
import { SkeletonLoader, Text } from "@hubble/web";
import CoinMetaDataListItem from "components/pages/Price/CoinPriceChart/CoinMetaDataListItem";
import {
  IconArrowUpRight,
  IconGraphBar,
  IconStepperInProgress
} from "@hubble/icons";
import { formatMarketCap, formatSupply } from "utils/currencies/formatters";
import { useConverterPageContext } from "utils/converter-provider";
import { formatVolume } from "components/pages/Derivatives/sections/utils";

const CoinMetricsCard: React.FC = () => {
  const t = useTranslations(FILES.CONVERTER);
  const { assetPrice, isRouting } = useConverterPageContext();
  const { toDisplayName, supply, volume, marketCap } = assetPrice ?? {};
  const volumeValue = formatVolume(parseFloat(volume?.value)) ?? "--";
  const supplyValue = formatSupply(parseFloat(supply?.value ?? "0")) ?? "--";
  const marketCapValue = formatMarketCap(marketCap?.value) ?? "--";
  return (
    <CoinMetricsCardContainer>
      {isRouting ? (
        <SkeletonLoader width="50%" height="24px" />
      ) : (
        <Text.Heading size="xs" marketing>
          {t("aboutCoinTitle", {
            name: toDisplayName ?? "Coin"
          })}
        </Text.Heading>
      )}
      <CoinMetricsCardStyled p={0} mt={2}>
        {isRouting ? (
          <SkeletonLoader width="100%" height="194px" />
        ) : (
          <CoinMetricsList>
            <CoinMetaDataListItem
              icon={<IconGraphBar />}
              label={t("marketCap")}
              value={marketCapValue}
            />
            <CoinMetaDataListItem
              icon={<IconArrowUpRight />}
              label={t("volume")}
              value={volumeValue}
            />
            <CoinMetaDataListItem
              icon={<IconStepperInProgress />}
              label={t("circulatingSupply")}
              value={supplyValue}
            />
          </CoinMetricsList>
        )}
      </CoinMetricsCardStyled>
    </CoinMetricsCardContainer>
  );
};

export default CoinMetricsCard;
